import { __extends } from "tslib";
import { exposeGetters } from '@skbkontur/react-ui/lib/theming/ThemeHelpers';
var AddonsTheme8px = /** @class */ (function (_super) {
    __extends(AddonsTheme8px, _super);
    function AddonsTheme8px() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //#region Logotype
    AddonsTheme8px.addonsLogoDividerHeight = '24px';
    AddonsTheme8px.addonsLogoDividerMarginX = '0';
    AddonsTheme8px.addonsLogoButtonActionBorderRadius = '50%';
    AddonsTheme8px.addonsLogoDividerWidth = '0px';
    AddonsTheme8px.addonsLogoButtonMarginLeft = '4px';
    AddonsTheme8px.addonsLogoWidgetPaddingX = '0px';
    AddonsTheme8px.addonsLogoButtonWidth = '32px';
    //#endregion
    //#region TopBar
    AddonsTheme8px.addonsTopBarShadow = '';
    AddonsTheme8px.addonsTopBarHeight = '32px';
    AddonsTheme8px.addonsTopBarItemBorderRadius = '4px';
    AddonsTheme8px.addonsTopBarItemActionBackground = 'rgba(0, 0, 0, 0.05)';
    AddonsTheme8px.addonsTopBarPaddingY = '16px';
    AddonsTheme8px.addonsTopBarPaddingX = '6px';
    AddonsTheme8px.addonsTopBarMarginBottom = '0';
    AddonsTheme8px.addonsTopBarItemPaddingX = '8px';
    AddonsTheme8px.addonsTopBarDividerHeight = '24px';
    AddonsTheme8px.addonsTopBarDividerMarginX = '8px';
    AddonsTheme8px.addonsTopBarOrganizationsArrowWidth = '24px';
    AddonsTheme8px.addonsTopBarIconColor = '#222';
    return AddonsTheme8px;
}(/** @class */ (function () {
    function class_1() {
    }
    return class_1;
}())));
export { AddonsTheme8px };
export var AddonsTheme8pxInternal = exposeGetters(AddonsTheme8px);
